<div class="w-full border-t border-[rgb(var(--ui-6))] bg-[rgb(var(--ui-7))] px-0 py-6 text-[rgb(var(--ui-5))] md:py-10">
    <div
        class="mx-auto box-border flex w-[95%] max-w-[1560px] flex-wrap items-center justify-center gap-2 px-4 text-[14px] leading-5 text-[rgb(var(--ui-1))] md:gap-4 md:px-[60px]"
    >
        @for (link of links(); track link.href; let isFirst = $first) {
            @if (!isFirst) {
                <span class="inline-flex w-auto items-center justify-center text-[rgb(var(--ui-5))]" aria-hidden="true"
                    >&bull;</span
                >
            }
            <a
                class="inline-flex cursor-pointer items-center text-[rgb(var(--ui-5))] no-underline hover:!text-[rgb(var(--ui-1))] hover:underline"
                [href]="link.href"
                target="_blank"
                rel="noreferrer"
            >
                {{ link.labelKey | translate: link.translationParams }}
            </a>
        }
    </div>
</div>
